import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleNotch } from '@fortawesome/free-solid-svg-icons';

export default ({ style = { color: 'white' } }) => <FontAwesomeIcon spin icon={faCircleNotch} style={style} />;
